<!-- LoginForm.vue -->
<template>
    <div class="form-container">
        <h2>Connexion</h2>
        <br>
        <form @submit.prevent="login">
            <div class="form-control">
                <label for="login-email">Votre adresse e-mail</label>
                <input type="email" id="login-email" v-model="email" required />
            </div>
            <div class="form-control">
                <label for="login-password">Mot de passe</label>
                <input type="password" id="login-password" v-model="password" required />
            </div>
            <div v-if="errorMessage" :class="{ errorMessage: true, error: !isSuccess }" class="message">
                {{ errorMessage }}
            </div>
            <button type="submit" class="button fill normal" :disabled="isSubmitting || isSuccess">Se connecter</button>
        </form>
        <span class="link forgot-password" @click="sendReset">Mot de passe oublié ?</span>
        <button v-if="currentForm !== 'VerificationForm'" @click="this.$router.push('/register')"
            class="button outline normal switch">
            Pas encore inscrit ? S'inscrire
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password: "",
            errorMessage: "",
            isSuccess: false,
            isSubmitting: false,
        };
    },
    methods: {
        async login() {
            this.errorMessage = "";
            this.isSuccess = false;
            this.isSubmitting = true;

            try {
                const body = JSON.stringify({ email: this.email, password: this.password });
                const response = await fetch(process.env.VUE_APP_API_URL + "user/login", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body, });
                const data = await response.json();

                this.isSubmitting = false;
                if (data.error) {
                    this.errorMessage = data.error;
                    this.isSuccess = false;
                } else {
                    this.isSuccess = true;
                    localStorage.removeItem('currentProperty');
                    localStorage.removeItem('type');
                    if (data.type == "franchise" || data.type == "user_franchise") {
                        localStorage.setItem("type", data.type);
                        this.$router.push("/franchise");
                    } else if (data.type == "root" || data.type == "admin") {
                        localStorage.setItem("type", data.type);
                        this.$router.push("/mondomicil-admin");
                    } else {
                        this.$router.push("/");
                    }
                }
            } catch (error) {
                this.errorMessage = "Une erreur est survenue lors de la connexion.";
                this.isSuccess = false;
                this.isSubmitting = false;
            }
        },
        async sendReset() {
            this.errorMessage = "";
            this.isSuccess = false;
            this.isSubmitting = true;

            try {
                if (!this.email) {
                    this.errorMessage = "Veuillez saisir une email.";
                    document.querySelector("#login-email").style.border = "1px solid #d9534f";
                    this.isSuccess = false;
                    return;
                }
                document.querySelector("#login-email").style.border = "1px solid #ccc";
                const body = JSON.stringify({ email: this.email });
                const response = await fetch(process.env.VUE_APP_API_URL + "user/reset", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body, });
                const data = await response.json();

                this.isSubmitting = false;
                if (data.error) {
                    this.errorMessage = data.error;
                    this.isSuccess = false;
                } else {
                    this.isSuccess = true;
                    this.errorMessage = "Un mail vous a été envoyé.";
                }
            } catch (error) {
                this.errorMessage = "Une erreur est survenue lors de la vérification.";
                this.isSuccess = false;
                this.isSubmitting = false;
            }
        },
    },
};
</script>